import React from 'react'
import { Button, PopUp } from '@ketch-com/deck'
import { Typography } from '@mui/material'

type Props = {
  onSubmit: () => void
  onCancel: () => void
}

export const ConfirmWebhookNavigationDialog: React.FC<Props> = ({ onSubmit, onCancel }) => {
  return (
    <PopUp
      title="Leaving This Page"
      popUpWidth="550px"
      variant="dialog"
      onClose={(_: object, reason: string) => {
        if (reason === 'backdropClick') {
          return
        }
        onCancel()
      }}
      popUpActionChildren={
        <>
          <Button color="secondary" size="large" onClick={onCancel}>
            Cancel
          </Button>
          <Button color="primary" size="large" onClick={onSubmit}>
            Continue
          </Button>
        </>
      }
    >
      <Typography>
        You are about to leave this page and all unsaved data will be lost, do you wish to continue?
      </Typography>
    </PopUp>
  )
}
